import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class MainLayoutWithNav extends Component {
  render() {
    return <div>{this.props.screens}</div>;
  }
}

export default withRouter(MainLayoutWithNav);



// WEBPACK FOOTER //
// ./src/components/layout/MainLayoutWithNav.js